module.exports = __webpack_public_path__ + "static/media/developer_activity.2c7a5e8d.svg";